import { ProgressItem as AntdProgressItem } from "@empglabs/backoffice-ui-kit"

const ProgressItem = props => {
  return <AntdProgressItem {...props} />
}

export default ProgressItem
